module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"modalTitle":"重新排序页"},"en":{"modalTitle":"Rearrange Pages"},"jp":{"modalTitle":"ページの順番を並べ替える"},"fr":{"modalTitle":"Réorganiser les Pages"},"de":{"modalTitle":"Seiten neu anlegen"},"es":{"modalTitle":"Reorganizar las página"},"pt":{"modalTitle":"Reajustar Páginas"},"it":{"modalTitle":"Riordina Pagine"},"tw":{"modalTitle":"重新排序頁"},"kr":{"modalTitle":"페이지 재정렬"}}')
  delete Component.options._Ctor
}
